import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import AxiosInstance from 'utils/AxiosInstance'
import { Row } from 'reactstrap'
import './AdminNavbar.css'

import { setSearchByGroups } from 'store/Group/actions'
import { setGroupSearch } from 'store/LearningPlan/actions'
import { markAsRead } from 'store/Notifications/actions'
import { getTimeAgo } from 'utils/helpers'
import { setHideSubmissionData } from 'store/EmployeeReport/actions'
import Submission from 'views/pages/Submission'
import { setShowSubmissionData } from 'store/EmployeeReport/actions'
import { setUserManually } from 'store/EmployeeReport/actions'
import { useState } from 'react'
import ViewSubmissionModal from 'views/pages/MaintenanceLog/ViewSubmissionModal'
import { setShowFormSubmission } from 'store/Forms/actions'
import { setFormSubmissionId } from 'store/Forms/actions'
import { setSubmissionModalData } from 'store/Forms/actions'
import { setFillFormModalData } from 'store/Forms/actions'
import { setJobDetailRoute } from 'store/Recruitment/actions'
import { APPEALS } from 'store/Recruitment/reducer'
import { toggleMessage } from 'store/commboard/actions'

export default function NavbarNotification({
  notification,
  navbar,
  selectedAlerts,
  closeDropdown,
}) {
  const dispatch = useDispatch()
  const history = useHistory()

  const employeeReport = useSelector((store) => store.employeeReport)
  const languageRedux = useSelector((state) => state.language.language?.data)
  const [selectedSubmissionId, setSelectedSubmissionId] = useState(null)
  const [showViewSubmissionModal, setShowViewSubmissionModal] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [selectedUserId, setSelectedUserId] = useState(null)

  const { showFormSubmission, selectedFormSubmissionId } = useSelector(
    (store) => store.form,
  )

  const {
    user: { access },
  } = useSelector((store) => store.auth)

  // const [showFormSubmission, setShowFormSubmission] = useState(false)
  // const [activeTab, setActiveTab] = useState(0)

  const data = JSON.parse(notification.data)

  const renderNotificationLink = () => {
    let notificationMessage =
      JSON.parse(notification?.notification)?.message || 'No message available'

    // Apply bold styling only if unread
    if (notification?.read === 0) {
      // Ensure only the outer <p> tag gets the bold styling
      notificationMessage = notificationMessage.replace(
        /<p([^>]*)>/,
        '<p$1 style="font-weight: bold;">',
      )
    }

    const handleSubmissionClick = (item) => {
      try {
        // setShowViewSubmissionModal(true)
        dispatch(setShowFormSubmission(true))
        dispatch(setFormSubmissionId(item.submissionId))
        setSelectedUserId(item.userId)
        setActiveTab(0)
      } catch (error) {
        console.error('Error parsing form submission data:', error)
        alert('Error opening form submission. Please try again.')
      }
    }

    switch (notification.type) {
      case 3: // Group Notifications
        return (
          <Link to='/learning-plan' className='d-block text-decoration-none'>
            <NotificationContainer notification={notification} navbar={navbar}>
              <p className='notification-message'>
                <span
                  dangerouslySetInnerHTML={{ __html: notificationMessage }}
                ></span>
                {data?.groups?.map((group, index) => (
                  <span
                    key={group}
                    style={{ fontSize: '1rem', fontWeight: 300 }}
                    onClick={() => {
                      dispatch(setSearchByGroups())
                      dispatch(setGroupSearch(group))
                    }}
                    className='notification-link'
                  >
                    {group}
                    {index < data.groups.length - 1 && ','}
                  </span>
                ))}
              </p>
            </NotificationContainer>
          </Link>
        )

      case 1:
      case 4:
      case 5:
      case 6:
        if (!data?.course_id) {
          console.error('Missing course_id for notification:', notification)
          return <div className='notification-error'>Invalid course data</div>
        }
        return (
          <Link
            to={`/course/${data.course_id}`}
            className='d-block text-decoration-none'
          >
            <NotificationContainer notification={notification}>
              <p dangerouslySetInnerHTML={{ __html: notificationMessage }}></p>
            </NotificationContainer>
          </Link>
        )

      case 2:
      case 7:
        return (
          <div className='d-block text-decoration-none'>
            <NotificationContainer notification={notification}>
              <p
                dangerouslySetInnerHTML={{
                  __html: notificationMessage,
                }}
              ></p>
            </NotificationContainer>
          </div>
        )

      case 8:
        return (
          <Link
            to={`/manager-reports/employee/${data.user_id}/checklist?course_id=${data.course_id}&referred_from_manager_report=true&from_notifications`}
          >
            <NotificationContainer notification={notification}>
              <p dangerouslySetInnerHTML={{ __html: notificationMessage }}></p>
            </NotificationContainer>
          </Link>
        )

      case 9:
        return (
          <>
            <div className='d-block text-decoration-none'>
              <NotificationContainer notification={notification}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: notificationMessage,
                  }}
                ></p>
              </NotificationContainer>
            </div>

            {employeeReport.isShowingSubmission &&
            employeeReport.currentSubmission ? (
              <Submission
                submission={employeeReport.currentSubmission}
                language={languageRedux}
                isShowing={employeeReport.isShowingSubmission}
                setHideSubmissionData={setHideSubmissionData}
                {...employeeReport}
              />
            ) : null}
          </>
        )

      case 10:
        return (
          <div
            onClick={() => {
              dispatch(
                setFillFormModalData({ show: true, formId: data.formId }),
              )
            }}
            className='d-block text-decoration-none'
          >
            <NotificationContainer notification={notification}>
              <p dangerouslySetInnerHTML={{ __html: notificationMessage }}></p>
            </NotificationContainer>
          </div>
        )

      case 11:
        return (
          <Link to={`/manager-reports/employee/${data.user_id}`}>
            <NotificationContainer notification={notification}>
              <p dangerouslySetInnerHTML={{ __html: notificationMessage }}></p>
            </NotificationContainer>
          </Link>
        )

      case 12:
        return (
          <>
            <div
              onClick={(e) => {
                handleSubmissionClick(data)
              }}
              className='d-block text-decoration-none'
            >
              <NotificationContainer notification={notification}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: notificationMessage,
                  }}
                ></p>
              </NotificationContainer>
            </div>
            {showFormSubmission &&
              selectedFormSubmissionId &&
              data.submissionId === selectedFormSubmissionId && (
                <ViewSubmissionModal
                  submissionId={selectedFormSubmissionId}
                  showViewSubmissionModal={showViewSubmissionModal}
                  setShowViewSubmissionModal={setShowViewSubmissionModal}
                  userId={access === 1 ? selectedUserId : null}
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                />
              )}
          </>
        )

      case 13:
        return (
          <>
            <Link
              onClick={() => dispatch(setJobDetailRoute(APPEALS))}
              to={`/job/details?job=${data.jobId}`}
            >
              <NotificationContainer notification={notification}>
                <p
                  dangerouslySetInnerHTML={{ __html: notificationMessage }}
                ></p>
              </NotificationContainer>
            </Link>
          </>
        )

      case 14:
        return (
          <div
            className='d-block text-decoration-none'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              AxiosInstance.get(`/library/single-file/${data.file_id}`).then(
                (file) => {
                  if (file.new_tab !== 0) {
                    window.open(file.path, '_blank')
                  } else {
                    history.push(`/library/url/${data.file_id}`)
                  }
                },
              )
            }}
          >
            <NotificationContainer notification={notification}>
              <p>
                <span
                  dangerouslySetInnerHTML={{ __html: notificationMessage }}
                ></span>{' '}
              </p>
            </NotificationContainer>
          </div>
        )

      case 15:
        return (
          <div
            className='d-block text-decoration-none'
            style={{ cursor: 'pointer' }}
            onClick={() => {
              dispatch(toggleMessage(data.message))
            }}
          >
            <NotificationContainer notification={notification}>
              <p dangerouslySetInnerHTML={{ __html: notificationMessage }}></p>
            </NotificationContainer>
          </div>
        )

      default:
        return (
          <Link
            to={`/notifications/${notification.id}`}
            className='d-block text-decoration-none'
          >
            <NotificationContainer notification={notification}>
              <p
                dangerouslySetInnerHTML={{
                  __html: notificationMessage,
                }}
              ></p>
            </NotificationContainer>
          </Link>
        )
    }
  }

  return (
    <div
      onClick={() => {
        dispatch(markAsRead([notification.id]))
        if (notification.type === 9) {
          dispatch(setUserManually(data.user_id))
          dispatch(setShowSubmissionData(data.course_id, data.user_id))
        }
        if (closeDropdown) {
          closeDropdown()
        }
      }}
      role='button'
      className={`list-group-item-action notification-item ${
        !navbar && selectedAlerts?.includes(notification?.id)
          ? 'active-notification'
          : ''
      } ${navbar ? 'border' : ''} dropdown-item`}
      style={{ borderRadius: !navbar && '10px' }}
    >
      {renderNotificationLink()}
    </div>
  )
}

const NotificationContainer = ({ notification, navbar, children }) => {
  return (
    <Row className='align-items-center notification-content borders'>
      <div className='col ml--2'>
        <div className='d-flex justify-content-between align-items-center'>
          {notification?.read === 0 ? (
            <span
              className='dot'
              style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: '#00d4ff',
                border: '2px solid white',
              }}
            ></span>
          ) : (
            ''
          )}
        </div>
        <div
          className={`${!navbar ? 'd-flex align-items-center' : ''}`}
          style={{ width: '90%' }}
        >
          {children}
        </div>
        <small className='text-muted'>
          {getTimeAgo(notification.created_at)}
        </small>
      </div>
    </Row>
  )
}
